import { render } from "./Create.vue?vue&type=template&id=5a0ce036&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=5a0ce036&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Nebula PC\\Coding\\web-projects\\snowchron\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0ce036"]])

export default __exports__